import React, { ReactNode } from 'react';

import { CommentAvatar } from 'features/comments';
import { Line, Square, Wrapper } from './styles';
import { Flex } from 'components';
import clsx from 'clsx';
import { useSchool } from 'features/school';
import { useTheme } from 'styled-components';

// import { Container } from './styles';

interface CommentRowProps {
  first?: boolean;
  letters?: string;
  level?: number;
  children: ReactNode;
}

const CommentRow = ({ first = false, level = 0, letters, children }: CommentRowProps) => {
  const { schoolAlias } = useSchool();
  const { colors } = useTheme();
  return (
    <Wrapper data-level={level}>
      <Line className={clsx({ first: level === 0 })}>
        {first ? (
          <Square style={{ background: schoolAlias === 'b3' ? colors.dark_150 : colors.primary_400, borderRadius: schoolAlias === 'b3' ? 20 : 0 }} />
        ) : (
          <CommentAvatar letters={letters} />
        )}
      </Line>

      <Flex flexGrow={1} pl={3} pb={{ d: level ? 20 : first ? 0 : 50 }}>
        <Flex minHeight={{ d: 58 }} flexDirection="column">
          {children}
        </Flex>
      </Flex>
    </Wrapper>
  );
};

export default CommentRow;
